import webClient from "../config/api.config";
import { LicencePricingUpdateRequest } from "../types/licencePricing.definition";

export function getAllLicencePricing() {
  return webClient.request({ method: "get", url: "/licence-pricing" });
}

export function updateLicencePricing(
  id: number,
  data: LicencePricingUpdateRequest
) {
  return webClient.request({
    method: "put",
    url: `/licence-pricing/${id}`,
    data,
  });
}
